import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function PublicRoute({ children, role }) {
  const isLoggedIn = useAuth(role);
  const auth = useSelector((state) => state.auth);

  return !isLoggedIn ? (
    children
  ) : auth?.user.role === "admin" ? (
    <Navigate to="/admin/dashboard" />
  ) : (
    <Navigate to="/course-player" />
  );
}
